import { injectIntl } from 'react-intl';

import DistrictUnitList from './DistrictUnitList';

export default injectIntl(DistrictUnitList);
